import { RouteItem } from '@eastcoal/router/types/route'

import { SALE_ANALYSIS_PAGE_UUID } from './constants/uuid'

export const saleAnalysisRoute: RouteItem = {
  title: '销售分析',
  uuid: SALE_ANALYSIS_PAGE_UUID,
  path: '/saleAnalysis',
  Component: () => import('./index')
}
